import { Link, useNavigate } from 'react-router-dom';
import { Button } from '@/components/ui/button';
import { useEffect } from 'react';

interface EmailSentPromptProps {
  email: string;
  devToken?: string;
}

export function EmailSentPrompt({ 
  email,
  devToken
}: EmailSentPromptProps) {
  const isDevelopment = process.env.NODE_ENV === 'development';
  const navigate = useNavigate();

  useEffect(() => {
    if (isDevelopment && devToken) {
      const handleKeyPress = (event: KeyboardEvent) => {
        if (event.key === 'Enter') {
          navigate(`/verify?token=${devToken}`);
        }
      };

      document.addEventListener('keydown', handleKeyPress);

      return () => {
        document.removeEventListener('keydown', handleKeyPress);
      };
    }
  }, [isDevelopment, devToken, navigate]);
  
  return (
    <div className="space-y-4 sm:space-y-6">
      <div className="text-center">
        <div className="text-lg font-medium text-gray-700">Check your email</div>
        <div className="text-base text-gray-600">
          We sent a magic link to <span className="font-medium">{email}</span>
        </div>
      </div>

      {isDevelopment && devToken && (
        <div className="p-6 bg-gray-100 space-y-4 text-center">
          <div className="space-y-1">
            <div className="text-sm font-medium text-gray-700">DEVELOPMENT MODE</div>
            <div className="text-sm text-gray-600">You can sign in without email access verification</div>
          </div>
          <Button asChild className="w-full lg:w-72">
            <Link to={`/verify?token=${devToken}`}>Sign in to Promo</Link>
          </Button>
        </div>
      )}
    </div>
  );
} 